import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import '@polymer/paper-card/paper-card.js';
import '@polymer/iron-image/iron-image.js';
import '@polymer/iron-form/iron-form.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-button/paper-button.js';
import '@polymer/paper-spinner/paper-spinner.js';
import '@polymer/paper-dropdown-menu/paper-dropdown-menu.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/paper-item/paper-item.js';


/**
 * `cbar-public-signup`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarPublicSignup extends PolymerElement {
  static get template() {
    return html`
      <style include="cbar-shared-styles">
        :host {
          display: block;
          background-size: cover;
          background-repeat: no-repeat;
          background-attachment: fixed;
          background-position: top left;
         
          @apply --cbar-public-signup;
        }
        #centered-card{
            width: 100%;
            height: auto;
            opacity: 0.95;
            
            @apply --cbar-signup-card;
        }
        #title{
            color: var(--cbar-public-signup-title-color, black);
            margin-bottom: 0;
            
            @apply --cbar-signup-title;
        }
        .full-width{
            width: 100%;
        }
        .half-width{
            width: 50%;
        }
        .sectioned-width{
            width: 80%;
            margin: 20px 0;
        }
        #logo {
            height: 100%;
            width: 100%;
            @apply --cbar-signup-logo;
        }
        .card-layout{
           display: flex;
           flex-direction: row;
           justify-content: space-evenly;
           @apply --cbar-signup-card-layout;
        }
       .card-left-div, .card-right-div{
         display: flex;
         flex: 1;
         padding: 16px;
        }
        .body-display-container{
            min-height: 100vh;
        } 
        .card-left-div{
            @apply --cbar-signup-left-div;
        }
       .card-right-div{
            @apply --cbar-signup-right-div;
        }
        #submit-div {
        text-align: right;
        }
        paper-spinner {
        margin-top: 15px;
        margin-right: 10px;
        }
        #submit-button{
        color: var(--cbar-signup-submit-color, white);
        background-color: var(--cbar-signup-submit-background-color, black);
        float: right;
        margin-top: 10px;
        }
        
        @media (max-width: 1000px) {
        .card-layout{
        flex-direction: column;
        }
        }
      </style>
        
      <div class="body-display-container">
        <div class="sectioned-width">
          <div class="full-width">
            <iron-image id="logo" src="[[logo]]" sizing="contain" position="[[logoPosition]]"></iron-image>
          </div>
          <paper-card id="centered-card">
            <div class="card-layout">
              <div class="card-left-div">
                <h2 id="title" style="margin-top: 0">[[title]]</h2>
                <slot name="left-div-content" id="card-left-div"></slot>
              </div>
              <div class="card-right-div">
                <slot name="right-div-content"></slot>
                <iron-form class="full-width" id="form" on-iron-form-response="__handleFormResponse">
                  <form action="[[formAction]]" method="[[formMethod]]">
                    <paper-input label="First Name" required$="[[firstNameRequired]]" hidden$="[[noFirstName]]" class="full-width" name="first_name" error-message="Invalid First Name" pattern="[[nameRegex]]"></paper-input>
                    <paper-input label="Last Name" required$="[[lastNameRequired]]" hidden$="[[noLastName]]" class="full-width" name="last_name" error-message="Invalid Last Name" pattern="[[nameRegex]]"></paper-input>
                    <paper-input label="Email" required$="[[emailRequired]]" hidden$="[[noEmail]]" class="full-width" name="email" error-message="Invalid Email Address" pattern="[[emailRegex]]"></paper-input>
                    
                    <paper-dropdown-menu label="Country" hidden$="[[noCountry]]" class="full-width" error-message="Required" id="country-dropdown" required$="[[countryRequired]]" no-animations>
                        <paper-listbox  slot="dropdown-content" attr-for-selected="value" selected="{{__selectedCountry}}">
                            <template is="dom-repeat" items="[[_countries]]" as="country">
                                <paper-item value="[[country.id]]">[[country.title]]</paper-item>
                            </template>
                        </paper-listbox>
                    </paper-dropdown-menu>
                    
                    <input type="hidden" name="country" value="[[__selectedCountry]]">
                    
                    <paper-dropdown-menu label="Role" disabled hidden required class="full-width" name="role" error-message="Required" id="roles-dropdown" no-animations>
                         <paper-listbox slot="dropdown-content" attr-for-selected="value" selected="{{__selectedRole}}">
                            <template is="dom-repeat" items="[[selectableRoles]]" as="role">
                                <paper-item value="[[role]]">[[role]]</paper-item>
                            </template>
                          </paper-listbox>
                    </paper-dropdown-menu>
                      
                      
                    <slot name="form-fields"></slot>
                    <div id="submit-div">
                        <paper-spinner active="[[__processing]]"></paper-spinner>
                        <paper-button on-tap="__submitForm" id="submit-button" disabled$="[[__processing]]">[[submitButtonLabel]]</paper-button>
                    </div>
                  </form>
                </iron-form>
              </div>
            </div>
          </paper-card>
        </div>
      </div>
    `;
  }
  static get properties() {
    return {
      /**
       * image that shows behind the centered card
       */
      backgroundImage: {
        type: String,
        value: false,
        observer: "__setBackgroundImage"
      },
      /**
       * title that displays below the logo resting right on top of the card
       */
      title : {
        type: String,
        value: ''
      },
      /**
       *  logo that shows at the top of the page
       */
      logo : {
        type: String,
        value: false
      },
      /**
       * where the logo sits within its image element
       */
      logoPosition: {
        type: String,
        value: 'left'
      },
      /**
       * the action that occurs when the form is submitted
       */
      formAction : {
        type: String,
        value: false
      },
      /**
       * method of the form
       */
      formMethod: {
        type: String,
        value: "POST"
      },
      /**
       * hides first name element
       */
      noFirstName: {
        type: Boolean,
        value: false
      },
      /**
       * hides last name element
       */
      noLastName: {
        type: Boolean,
        value: false
      },
      noCountry: {
        type: Boolean,
        value: false
      },
      countries: {
        type: Array,
        value: [],
      },
      /**
       * hides email element
       */
      noEmail: {
        type: Boolean,
        value: false
      },
      /**
       * makes first name element required
       */
      firstNameRequired: {
        type: Boolean,
        value: false
      },
      /**
       * makes last name element required
       */
      lastNameRequired: {
        type: Boolean,
        value: false
      },
      /**
       * makes email element required
       */
      emailRequired: {
        type: Boolean,
        value: false
      },
      countryRequired : {
        type: Boolean,
        value: false
      },
      __processing : {
        type: Boolean,
        value: false
      },
      selectableRoles: {
        type: Array,
        value: [],
        observer: "__determineVisibleRoles"
      },
      submitButtonLabel : {
        type: String,
        value: "Submit"
      },
      emailRegex: {
        type: String,
        value: "^[\\w\\-.àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+@([\\w\\-àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+.)+[\\w\\-àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]{2,}$"
      },
      nameRegex: {
        type: String,
        value: "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.'\\s\\-]+$"
      }
    };
  }

  static get observers(){
    return [
      'handleCountries(countries.splices)'
    ]
  }

  /**
   * get the iron-pages element in here to use
   * @return {PolymerElement}
   */
  get form(){
    if(!this._form){
      this._form = this.root.querySelector('iron-form');
    }
    return this._form;
  }

  get rolesDropdown(){
    if(!this.__rolesDropdown){
      this.__rolesDropdown = this.root.querySelector('#roles-dropdown');
    }
    return this.__rolesDropdown
  }

  /**
   * This is in place in order for us to programatically set the background image, this is due to the fact that bindings do not
   * work inside CSS, so we have to do this here
   * @param image
   * @private
   */
  __setBackgroundImage(image){
    if(!image){
      return;
    }
    this.style.backgroundImage = `url(${image})`;
  }

  /**
   * If the user can only select one role then we shouldnt be showing the dropdown
   * @private
   */
  __determineVisibleRoles(rolesArray){
    this.rolesDropdown.hidden = this.rolesDropdown.disabled = rolesArray.length < 2;
  }


  /**
   * if we have a form action, we need to submit the form when the button is clicked, however we need to check if we have a formaction first
   * and that the form itself is valid
   * @param e
   * @private
   */
  __submitForm(e){
    this.__processing = true;
    if(!this.formAction || this.form.validate() === false){
      this.__processing = false;
      return;
    }

    this.form.submit();
  }

  __handleFormResponse(e){
    this.dispatchEvent(new CustomEvent('form-response', {
      bubbles: true,
      composed: true,
      detail: {
        event: e
      }
    }));

    this.__processing = false;
  }

  clear(){
    this.form.reset();

    this.__selectedCountry = null;
    this.__selectedRole = null;
  }

  handleCountries(){
      if(this._removingFromAttribute && this.countries.length === 0){
        this._removingFromAttribute = false;
        return;
      }

      this._countries = this.countries;

      this._removingFromAttribute = true;
      this.removeAttribute('countries');
  }
}

window.customElements.define('cbar-public-signup', CbarPublicSignup);
